import { addEventListeners } from "../utils/dom";

export default class ScrollToTop extends HTMLDivElement {

    observer = null;

    // min number of pixels to scroll the button
    minHeight = 2000;

    connectedCallback() {

        // Set the minheight to 3 screens so that it appears after about 2 screens
        this.minHeight = window.innerHeight * 3;

        const scrollTrigger = document.getElementById("scroll-to-top-trigger");

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {

                if (entry.isIntersecting) {
                    this.classList.add("show");
                } else {
                    this.classList.remove("show");

                }
            });
        });

        this.observer.observe(scrollTrigger);

        window.addEventListener("load", () => {

            const pageHeight = document.body.offsetHeight;

            if (pageHeight <= this.minHeight - this.offsetHeight)
                return;

            scrollTrigger.style.top = this.minHeight + "px";
            scrollTrigger.style.height = (pageHeight - this.minHeight) + "px";
            scrollTrigger.style.display = "block";
        });

        // Recalculate after lazy loaded images have loaded
        setTimeout(() => {

            addEventListeners("img", "load", (e) => {

                const pageHeight = document.body.offsetHeight;

                if (pageHeight <= this.minHeight - this.offsetHeight)
                    return;

                scrollTrigger.style.top = this.minHeight + "px";
                scrollTrigger.style.height = (pageHeight - this.minHeight) + "px";
                scrollTrigger.style.display = "block";

            });

        }, 5000);

    }
}

customElements.define('scroll-to-top', ScrollToTop, { extends: 'div' });